import { css } from "@emotion/react";
export const spacer = css`
  &:not(div:first-of-type) {
    padding-top: 0.5rem;
  }
`;

export const radioLabel = css`
  div:last-of-type::first-letter {
    text-transform: capitalize;
  }

  max-width: 93%;
`;
